import ru from './ru'
import uz from './uz'
import en from './en'

export default {
  ru,
  uz,
  en
}